// @ts-strict-ignore
import clsx from 'clsx'
import { useEffect, useState } from 'react'

import { ProductButtons } from '@/widgets/ProductButtons/ProductButtons'

import { useCart } from '@/entities/cart'

import { CatalogItemLocation } from '@/shared/types/deprecated-types'
import { OrderType, ProductControl, TProduct, TProductCode } from '@/shared/types/product-types'
import { ButtonProps } from '@/shared/ui'

import cl from './buy-buttons-panel.module.scss'

export type BuyButtonsPanelProps = {
	fullWidth?: boolean
	ID_BASKET?: number
	fastOrderBtnType?: ButtonProps['theme']
} & TProduct

type InCartInfoTypes = {
	count: number
	productCode: TProductCode
}

/**
 * Panel with buy buttons in product carts
 * @param props
 */
export const BuyButtonsPanel = (props: BuyButtonsPanelProps): JSX.Element => {
	const { KOD, ID, ORDER_TYPE, CONTROL, fullWidth = true } = props
	const [inCartInfo, setInCartInfo] = useState<InCartInfoTypes | undefined>(null)
	const { products } = useCart()

	useEffect(() => {
		const isProductInCart = products.find(product => product.ID === ID)

		if (!isProductInCart && inCartInfo) {
			setInCartInfo(null)

			return
		}

		if (!isProductInCart) return

		setInCartInfo({
			count: isProductInCart.QUANTITY,
			productCode: KOD
		})
	}, [products])

	if (ORDER_TYPE === OrderType.Archive || CONTROL?.includes(ProductControl.HideBuy)) return null

	return (
		<section className={clsx(cl.buyButtonsPanel, fullWidth && cl.fullWidth)}>
			<ProductButtons
				productInfo={props}
				big
				fastOrderBtnType="outlined"
				location={CatalogItemLocation.ProductCard}
				isProductPage
			/>
		</section>
	)
}
